/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Značky`
};

const da_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Mærker`
};

const de_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Marken`
};

const en_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Brands`
};

const es_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Marcas`
};

const fr_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Marques`
};

const hu_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Márkák`
};

const it_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Marche`
};

const nl_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Merken`
};

const pl_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Marki`
};

const pt_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Marcas`
};

const sv_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Varumärken`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const brands = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.brands(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("brands", locale)
	if (locale === "cs") return cs_brands(inputs)
	if (locale === "da") return da_brands(inputs)
	if (locale === "de") return de_brands(inputs)
	if (locale === "en") return en_brands(inputs)
	if (locale === "es") return es_brands(inputs)
	if (locale === "fr") return fr_brands(inputs)
	if (locale === "hu") return hu_brands(inputs)
	if (locale === "it") return it_brands(inputs)
	if (locale === "nl") return nl_brands(inputs)
	if (locale === "pl") return pl_brands(inputs)
	if (locale === "pt") return pt_brands(inputs)
	return sv_brands(inputs)
};